import React from 'react';
import '../fallbackPage.scss';
import { showContentfulLinks } from './globalHelpers';
import { ReplaceWithIssues } from "./ReplaceWithIssues"
import { DecorateWithContentfulLinks } from "./DecorateWithContentfulLinks"

export const IssuesWrapper = ({ children, parent, elementName, targetNodes = [],  targetPaths = [], hideChildrenWithIssues = true }) => {

  const args = { children, parent, elementName, targetNodes, targetPaths, hideChildrenWithIssues }
  if(showContentfulLinks()){
    return <DecorateWithContentfulLinks {...args}/>
  }

  return <ReplaceWithIssues {...args}/>

};

